import { Component, OnInit, Input } from '@angular/core';

@Component({
	selector: 'error-message',
	templateUrl: './error-message.component.html',
	styleUrls: ['./error-message.component.scss']
})

export class errorMessageComponent implements OnInit{

	@Input() tooltipMessage: boolean | undefined;
	@Input() validatorMessage: boolean | undefined;
	@Input() controls: any;
	@Input() label: any;
	@Input() submitted: boolean | undefined;

	constructor() { }

	ngOnInit() {

	}

}
